export const MAX_POLL_OPTIONS = 100;
export const MAX_OPTIONS_DISPLAYED = 10;
